export interface ApiClientError extends Error {
  status?: number;
}

export function getApiClientErrorStatus(error: unknown): number | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const status = (error as ApiClientError).status;
  return typeof status === 'number' ? status : undefined;
}
